module.exports = __webpack_public_path__ + "img/tick-read.c4f7fc39.svg";